module.exports = __webpack_public_path__ + "static/03.7f646e0b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/carousel/03.mp4
// module id = 987
// module chunks = 35783957827783